export default __webpack_public_path__ + "static/stamp-beige-9e4edb3e3e55eecc6dcc0319816c34e1.svg";